import WeightCheck from '@features/WeightCheck/ui/WeightCheck';

export default function WeightCheckPage() {
  return <WeightCheck />;
}
